// extracted by mini-css-extract-plugin
module.exports = {"pilltagGroup":"pilltag_group_pilltagGroup__PQeq8","viewAll":"pilltag_group_viewAll__BagPb"};